const createTimeStamp = () => new Date().toLocaleTimeString([], {hour: 'numeric', minute:'2-digit'});

export {
    createTimeStamp
}